export function activate () {
  const domainFormH = window.$('.domainForm').height()
  const domainTxt = window.$('.domainTxt')
  const domainTxtH = domainTxt.height()
  const domainTxtP = (domainFormH - domainTxtH) / 2

  domainTxt.css('padding-top', domainTxtP + 'px')

  window.$(window).load(function () {
    const ctaImgOne = window.$('.ctaImgOne')
    const ctaImgOneH = ctaImgOne.height()
    const ctaRight = window.$('.ctaRight')
    ctaRight.height(ctaImgOneH)

    const ctaImgTwo = window.$('.ctaImgTwo')
    const ctaImgTwoH = ctaImgTwo.height()
    const ctaLeft = window.$('.ctaLeft')
    ctaLeft.height(ctaImgTwoH)
  })

  // var langOpt = window.$('.lang li'),
  //     langTxt = window.$('.langIcon .langCode')
  // langOpt.on('click', function () {
  //   var langCode = window.$(this).attr('data-code')
  //   langTxt.text(langCode)
  // })

  window.$('.singleDomain a.cartBtn').on('click', function () {
    window.$(this).parent('.singleDomainRight').parent('li.singleDomain').toggleClass('active')
    window.$(this).toggleClass('added')
  })
  window.$('.btnCart.Btn').on('click', function () {
    window.$(this).toggleClass('added')
  })

  const windowWidth = window.$(window).width()

  // if (windowWidth > 767) {
  //   const cursorWidthxx = '14px'
  // } else {
  //   const cursorWidthxx = '10'
  // }

  window.$('.duration span').on('click', function () {
    window.$(this).siblings('ul').toggleClass('active')
    window.$(this).siblings('ul').mouseleave(function () {
      window.$(this).removeClass('active')
    })
  })
  // window.$('ul.cartOpt li').on('click', function () {
  //   window.$(this).parent('ul').removeClass('active')
  //   var cartCode = window.$(this).attr('data-code')
  //   var cartPrice = window.$(this).attr('data-price')
  //   window.$(this).parent('ul').siblings('span').text(cartCode)
  //   window.$(this).parent('ul').parent('.duration').siblings('.total').text(cartPrice)
  // })
  // window.$('span.closeIcon').on('click', function () {
  //   window.$(this).parent('.product').parent('li').remove()
  // })

  window.$(function () {
    window.$('[data-toggle="tooltip"]').tooltip()
  })
  window.$(window).load(function () {
    if (window.$.fn.owlCarousel) {
      window.$('.tstSlider').owlCarousel({
        items: 2,
        loop: true,
        navText: ['<i class="icofont icofont-simple-left"></i>', '<i class="icofont icofont-simple-right"></i>'],
        nav: true,
        dots: false,
        smartSpeed: 600,
        autoplayTimeout: 7000,
        responsive: {
          0: {
            items: 1
          },
          991: {
            items: 2
          }
        }
      })

      var homeSlider1 = window.$('.homeSlider1')
      homeSlider1.owlCarousel({
        items: 1,
        autoplay: true,
        loop: true,
        navText: ['<i class="icofont icofont-simple-left"></i>', '<i class="icofont icofont-simple-right"></i>'],
        nav: true,
        dots: false,
        smartSpeed: 50,
        responsive: {
          0: {
            smartSpeed: 500
          },
          992: {
            smartSpeed: 50
          }
        }
      })

      if (windowWidth > 991) {
        homeSlider1.on('translate.owl.carousel', function () {
          homeSlider1.find('.owl-item .homeImgTable').removeClass('fadeInLeft animated').fadeOut(0)
          homeSlider1.find('.owl-item .homeContent > *').removeClass('fadeInRight animated').css('opacity', '0')
        })
        homeSlider1.on('translated.owl.carousel', function () {
          homeSlider1.find('.owl-item.active .homeImgTable').addClass('fadeInLeft animated').fadeIn(0)
          homeSlider1.find('.owl-item.active  .homeContent > *').addClass('fadeInRight animated').css('opacity', '1')
        })
      }

      var arrowPos
      if (windowWidth > 1199) {
        arrowPos = (windowWidth - 1140) / 2
      } else if (windowWidth > 991 && windowWidth < 1200) {
        arrowPos = (windowWidth - 940) / 2
      } else if (windowWidth > 767 && windowWidth < 992) {
        arrowPos = (windowWidth - 720) / 2
      } else {
        window.$('.homeSlider1 .owl-nav div').remove()
      }

      window.$('.homeSlider1 .owl-nav div.owl-next i').css('right', '-' + arrowPos + 'px')
      window.$('.homeSlider1 .owl-nav div.owl-prev i').css('left', '-' + arrowPos + 'px')
    }
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/carossel.js